import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as eruda from 'eruda'
import { App } from './App'
import './styles/main.css'

eruda.init()
const container = document.getElementById('app')
const root = createRoot(container)
root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
